<template>
  <div v-if="!loading" :style="style" class="loader-box">
    <div v-if="color === 'dark'" :class="`w-100 h-100 d-flex justify-content-center`">
      <!-- <img src="../../../public/img/logo_apolo_loader_dark.svg" alt="" :class="`h-${height} w-${width}`"> -->
      <img src="../../../public/img/novo-branding/logo-apolo-animada.svg" alt="" :class="`h-${height} w-${width}`">
    </div>
    <div v-if="color === 'white'" :class="`w-100 h-100 d-flex justify-content-center`">
      <!-- <img src="../../../public/img/logo_apolo_loader_white.svg" alt="" :class="`h-${height} w-${width}`"> -->
      <img src="../../../public/img/novo-branding/logo-apolo-animada.svg" alt="" :class="`h-${height} w-${width}`">
    </div>
  </div>
</template>

<script>
export default {
  name: "loader",
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    height: {
      type: String,
      required: false,
      default: "25",
    },
    width: {
      type: String,
      required: false,
      default: "25",
    },
    speed: {
      type: String,
      required: false,
      default: "1s",
    },
    color: {
      type: String,
      required: false,
      default: "white",
    },
  },
  computed: {
    style() {
      return {
      };
    },
    animation() {
      return { animation: `spin infinite ${this.speed}` };
    },
  },
};
</script>

<style>
.loader-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.loader_refresh {
  width: 100%;
  animation: spin infinite 1s;
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.w-10 {
  width: 10%;
}
.h-10 {
  height: 10%;
}
</style>
